import { render, staticRenderFns } from "./PurchaseOrderView.vue?vue&type=template&id=4f20b4f6"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports